import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectTeamById } from "../../../../../../redux/slices/teamsSlice";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import { setAppTeamModalOpen } from "../../../../../../redux/slices/appSettingsSlice";
import JoinTeamButton from "./JoinTeamButton";

const ConnectedJoinTeamButton = ({ id }) => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;

    const team = useSelector((state) => selectTeamById(state, id));

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );
    const {
        options: {
            joinTeamModal: { joinTeamButtonLabel = "Join" },
        },
    } = control;

    const joinTeamButtonProps = {
        ...team,
        joinTeamButtonLabel,
        setAppTeamModalOpen,
    };

    return <JoinTeamButton {...joinTeamButtonProps} />;
};

ConnectedJoinTeamButton.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ConnectedJoinTeamButton;
